import { ChangeDetectionStrategy, Component } from '@angular/core';
import { isDefined } from '@evorait/pace-core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { getFormHintsForFilling } from '../../store/selectors/form.selector';
import { FormsState } from '../../store/state/pace-forms.state';
import { Abbreviation, HintsForFilling } from '../../types/hints-for-filling';

@Component({
    selector: 'pace-forms-hints-for-filling',
    templateUrl: './hints-for-filling.component.html',
    styleUrls: ['./hints-for-filling.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HintsForFillingComponent {
    public hints$: Observable<HintsForFilling>;
    public constructor(private readonly store: Store<FormsState>) {
        this.hints$ = this.store.select(getFormHintsForFilling).pipe(filter(isDefined));
    }

    public trackByFn(index: number, item: Abbreviation): string {
        return item.abbreviation;
    }
}
